import moment from "moment";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Task Title",
    dataIndex: "taskName",
    render: defaultRender,
  },
  // {
  //   title: "Completed By",
  //   dataIndex: "user",
  //   render: value => value?.name || "--",
  // },
  {
    title: "Message",
    dataIndex: "message",
    render: defaultRender,
    width : 200
  },
  {
    title: "Assigned From",
    dataIndex: "assigned_from",
    render: (value) => value?.name || "--",
    width : 150
  },
  {
    title: "Assigned To",
    dataIndex: "assigned_to",
    render: (value) => value?.name || "--",
    width : 150
  },
  {
    title: "Assigned By",
    dataIndex: "assigned_by",
    render: (value) => value?.name || "--",
    width : 150
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value) => moment(value)?.format("lll"),
    width : 150
  },
];

export default columns;
